<template>
	<svg width="12" height="20" viewBox="0 0 11 18" fill="none" aria-hidden="true">
		<path d="M1.5 1.5 9 9l-7.5 7.5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path>
	</svg>
</template>
